// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"bafa3b1e","826":"b6e1827e"}[chunkId] + ".chunk.css";
};